const state = {
	productDetail : {},
	matchDetail : {}
}

const mutations = {
	changeProductDetail (state,payload){
		state.productDetail = payload;
	},
	changeMatchDetail (state,payload){
		state.matchDetail = payload;
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/orderingDialog.js